import { IViewModel } from '../interface/view-model.interface';

const EXCEPT_PROPERTY = ['applyModel', 'modelToObject', 'initModel'];
/**
 * model基类，主要实现了model赋值
 */
export default abstract class BaseViewModel<P = {}> implements IViewModel<P> {
    /**
     * 更新model数据
     * @param updateModel
     */
    public applyModel(updateModel: Partial<this>) {
        Object.keys(updateModel).forEach((keyItem) => {
            if (this.getExceptPropsArray().includes(keyItem)) return;
            this[keyItem] = updateModel[keyItem];
        });
    }

    /**
     * model转成普通对象。子类可重写
     */
    public modelToObject(): Partial<this> {
        const obj: Partial<this> = { };
        Object.keys(this).forEach((keyItem) => {
            if (this.getExceptPropsArray().includes(keyItem)) return;
            obj[keyItem] = this[keyItem];
        });
        return obj;
    }

    /**
     * 转成对象或赋值时，过滤哪些字段。子类可重写
     * @protected
     */
    protected getExceptProperties() {
        return [];
    }

    private getExceptPropsArray() {
        return EXCEPT_PROPERTY.concat(this.getExceptProperties());
    }

    public abstract initModel(props?: P, initObj?: Partial<this>): void;
}
